import React, { Component, Fragment } from 'react'
import styles from './age-groups-select.styles'
import injectSheet from 'react-jss'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import Bone from 'pobble-components/dist/bone'

const AgeGroupsOptions = ({ ageGroups, selectOption }) => (
  <Fragment>
    {ageGroups.map(({ id, title }) => (
      <option key={id} value={id}>
        {title}
      </option>
    ))}
  </Fragment>
)

class AgeGroupsSelect extends Component {
  componentDidMount() {
    const { fetchAgeGroups, ageGroups } = this.props
    if (fetchAgeGroups && !ageGroups) fetchAgeGroups()
  }
  render() {
    const {
      classes,
      className,
      formSelectProps,
      ageGroups,
      fetching,
      fetchingError,
      selectOption
    } = this.props
    return fetching ? (
      <Bone className={classes.bone} />
    ) : fetchingError ? (
      <div className={classes.fetchingError}>Try reload the page</div>
    ) : (
      <FormSelect className={className} {...formSelectProps}>
        {selectOption && <option value="">{selectOption}</option>}
        {!formSelectProps.value && <option value="">Missing</option>}
        <AgeGroupsOptions ageGroups={ageGroups} />
      </FormSelect>
    )
  }
}

export default injectSheet(styles)(AgeGroupsSelect)
